export default "__VITE_ASSET__UOrBDG8e__"